import EventCategoryFilter from './eventCategories';

export default EventCategoryFilter;
